import { useTranslation } from "react-i18next";
import {
  AsyncCallArgs,
  BoxSpg,
  GridContainer,
  GridItem,
  handleFormSubmission,
  InputFormField,
  SubmitFormButton,
  useAsyncCall,
  useReactHookForm,
  ViewDialog,
} from "@duosoftbg/nacid-components";
import useAppDispatch from "../../../../../../../../hooks/redux/base/useAppDispatch";
import useAppSelector from "../../../../../../../../hooks/redux/base/useAppSelector";
import { closeModal } from "../../../../../../../../store/redux/slice/ComponentsControl/myAccountControl";
import { FormProvider } from "react-hook-form";
import { userChangePassword } from "../../../../../../../../axios/api/services";
import { toast } from "react-toastify";
import { Typography } from "@mui/material";
import React from "react";
import { ChangePasswordDetails } from "../../../../../../../../types/resetPasswordTypes";
import { changeUserPasswordInitialValues } from "../../../../../../../../init/changeUserPasswordInitialValues";
import { createPasswordConfirmationValidationSchema } from "../../../../../../../../yup/schema/password/base/passwordConfirmationValidationSchema";

const PasswordChangeDialog = () => {
  const { t } = useTranslation();
  const { asyncCall } = useAsyncCall();
  const dispatch = useAppDispatch();

  const { methods } = useReactHookForm<ChangePasswordDetails>({
    defaultValues: changeUserPasswordInitialValues,
    validationSchema: createPasswordConfirmationValidationSchema,
  });

  const onSubmit = (values) => {
    const asyncPasswordChange: AsyncCallArgs = {
      promise: userChangePassword(values),
      reactHooksForm: { methods },
      onSuccess: () => {
        toast.success(t("m.user.change.password.success"));
        handleCloseDialog();
      },
    };
    asyncCall(asyncPasswordChange);
  };

  const { open } = useAppSelector((state) => {
    return state.ComponentsControl.myAccountControl.modals.passwordChange;
  });

  const handleCloseDialog = () => {
    methods.reset(changeUserPasswordInitialValues);
    dispatch(closeModal({ modalType: "passwordChange" }));
  };

  return (
    <ViewDialog open={open} onClose={handleCloseDialog} title={"t.change.password.dialog"}>
      <FormProvider {...methods}>
        <form onSubmit={handleFormSubmission({ methods, onSubmitFn: onSubmit, t })}>
          <GridContainer spacing={3}>
            <GridItem sm={12} md={12}>
              <BoxSpg style={{ whiteSpace: "pre-line" }}>
                <InputFormField
                  required={true}
                  type={"password"}
                  fieldName={"password"}
                  labelCode={"l.user.password"}
                />
              </BoxSpg>
            </GridItem>
            <GridItem sm={12} md={12}>
              <InputFormField
                required={true}
                type={"password"}
                fieldName={"confirmPassword"}
                labelCode={"l.user.confirmPassword"}
              />
            </GridItem>
            <GridItem sm={12} md={12}>
              <Typography align={"right"}>
                <SubmitFormButton label={"l.btn.submit"} />
              </Typography>
            </GridItem>
          </GridContainer>
        </form>
      </FormProvider>
    </ViewDialog>
  );
};

export default PasswordChangeDialog;
